import React from 'react';

import UserProfile from "./components/UserProfile";

function Profile(props) {
    return (
        <div style={{
            marginTop: '12px',
            marginBottom: '0',
            paddingLeft: '12px',
            paddingRight: '12px'
        }}>
            <UserProfile />
        </div>
    );
}

export default Profile;
